import React from "react";
import {
    WAVE_HEIGHT,
    WAVE_OFFSET_X_LEFT,
    WAVE_OFFSET_Y,
    WAVE_SVG_HEIGHT,
    WAVE_VIEWBOX,
    WAVE_WIDTH
} from "../utils/svg";

interface AxisProps {
    offset: number     // 0..1
}

export const WaveAxis = ({offset}: AxisProps) => {

    // SVG Y axis has 0 on top

    return (
        <svg viewBox={WAVE_VIEWBOX}>
            <line x1={WAVE_OFFSET_X_LEFT}              y1={WAVE_SVG_HEIGHT - WAVE_OFFSET_Y}
                  x2={WAVE_OFFSET_X_LEFT + WAVE_WIDTH} y2={WAVE_SVG_HEIGHT - WAVE_OFFSET_Y} stroke="#555" />
            <line x1={WAVE_OFFSET_X_LEFT}              y1={WAVE_OFFSET_Y}
                  x2={WAVE_OFFSET_X_LEFT}              y2={WAVE_HEIGHT + WAVE_OFFSET_Y} stroke="#555" />
            <line x1={WAVE_OFFSET_X_LEFT}              y1={WAVE_SVG_HEIGHT - (WAVE_OFFSET_Y + offset * WAVE_HEIGHT)}
                  x2={WAVE_OFFSET_X_LEFT + WAVE_WIDTH} y2={WAVE_SVG_HEIGHT - (WAVE_OFFSET_Y + offset * WAVE_HEIGHT)} stroke="blue" />
        </svg>
    );

};
